import React, { useState, useRef } from "react";
import { useRecoilState } from "recoil";
import { langState } from "./recoilAtom";
import { linksData } from "./header";
import { ContentWrapper } from "./layout";
import { Link } from "gatsby";
import {
  EnvelopeFill,
  TelephoneFill,
  Linkedin,
  Youtube,
} from "react-bootstrap-icons";
import { StaticImage } from "gatsby-plugin-image";

interface footerProps {
  children?: React.ReactNode;
  className?: string;
}

const currentYear = new Date().getFullYear();

const contactDetails: any = {
  "pl-PL": {
    Contact: `Kontakt`,
    phone: `+48 725 500 051`,
    phoneHref: `+48725500051`,
    emailAddress: `biuro@medinice.pl`,
    address: `Adres`,
    streetDetails: `ul. Hankiewicza 2`,
    postalcodeDetails: `02-103 Warszawa`,
    countryName: ``,
    linksTitle: `Linki`,
    copyrightText: `${currentYear} © Medinice S.A.`,
    privacyPolicy: `Regulamin i Polityka prywatności`,
  },
  "en-US": {
    Contact: `Contact`,
    phone: `+48 725 500 051`,
    phoneHref: `+48725500051`,
    emailAddress: `biuro@medinice.pl`,
    address: `Address`,
    streetDetails: `Hankiewicza 2`,
    postalcodeDetails: `02-103 Warszawa`,
    countryName: `Poland`,
    linksTitle: `Quick links`,
    copyrightText: `${currentYear} © Medinice S.A.`,
    privacyPolicy: `Terms & Conditions and Privacy Policy`,
  },
};

const Footer: React.FC<footerProps> = ({ children, className }) => {
  const [lang, setLang] = useRecoilState(langState);

  return (
    <footer
      className={`${className} flex w-full items-center justify-center bg-slate-100 py-10`}
    >
      <ContentWrapper>
        <div className="w-full flex">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 w-full">
            <div className="flex flex-col gap-4">
              <h3 className="text-lg font-bold">
                {contactDetails[lang].linksTitle}
              </h3>
              <ul className="flex flex-col gap-2">
                {linksData[lang].map((linkItem, idx) => (
                  <li key={idx + "footer-top"}>
                    <Link
                      className="flex items-center hover:text-blue-600"
                      to={linkItem.url}
                    >
                      {linkItem.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex flex-col gap-2">
              <h3 className="text-lg font-bold mt-2 lg:mt-0">
                {contactDetails[lang].Contact}
              </h3>

              <div className="flex flex-col gap-2">
                <a
                  href={`tel:${contactDetails[lang].phoneHref}`}
                  className="flex items-center gap-2 hover:text-blue-600"
                >
                  <TelephoneFill />
                  {contactDetails[lang].phone}
                </a>
                <a
                  href={`mailto:${contactDetails[lang].emailAddress}`}
                  className="flex items-center gap-2 hover:text-blue-600"
                >
                  <EnvelopeFill />
                  {contactDetails[lang].emailAddress}
                </a>
              </div>
              <h4 className="font-bold mt-4">{contactDetails[lang].address}</h4>
              <div className="flex flex-col gap-2">
                <p>{contactDetails[lang].streetDetails}</p>
                <p>{contactDetails[lang].postalcodeDetails}</p>
                <p>{contactDetails[lang].countryName}</p>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <h3 className="text-lg font-bold mt-2 lg:mt-0">
                {lang === "pl-PL" ? <>Zobacz nas na</> : <>Follow us</>}
              </h3>
              <div className="flex flex-col gap-2">
                <div className="flex gap-4 items-center">
                  <a
                    href="https://www.linkedin.com/company/medinice.pl/"
                    className="hover:text-blue-600"
                    // target="_blank"
                  >
                    <Linkedin className="min-w-6 min-h-6" />
                  </a>
                  <a
                    href="https://www.youtube.com/results?search_query=Medinice+"
                    // target="_blank"
                  >
                    <Youtube className="min-w-12 min-h-8 hover:text-blue-600" />
                  </a>
                  {/* <a
                    href="https://www.facebook.com/medinice/?locale=pl_PL"
                    // target="_blank"
                  >
                    <Facebook />
                  </a> */}
                </div>
              </div>
              <div className="flex flex-col gap-1 mt-8">
                <p>NIP: 6631868308</p>
                <p>REGON: 260637552</p>
                <p>KRS: 0000443282</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 lg:gap-0 items-start lg:items-center justify-start w-full mt-8">
          <div className="flex flex-col lg:flex-row gap-2">
            <span>{contactDetails[lang].copyrightText}</span>
            <a className="underline hover:text-blue-600" href="/privacy-policy">
              {contactDetails[lang].privacyPolicy}
            </a>
          </div>
        </div>
      </ContentWrapper>
    </footer>
  );
};

export default Footer;
